import {expectEither, HttpClient} from '@raison/network-facade';
import {CurrencyCode} from '@raison/types';
import {StandardSchemaV1} from '@standard-schema/spec';
import {type} from 'arktype';
import {Decoder} from '@raison/prelude';
import {unSnakeByMutation} from '~/library/toolbox';
import defaultIcon from '~/shared/legacy_res/img/svg/default.svg';
import {CurrencyInfo} from '../model/Currency';

export async function fetchCurrenciesInfo(http: HttpClient, quoteCurrencyCode?: string) {
    const params = new URLSearchParams();
    if (quoteCurrencyCode) {
        params.set('quote', quoteCurrencyCode);
    }
    const response = await http(`v1/currencies?${params}`).then(
        ...expectEither({
            200: CurrencyInfosSchema,
        })
    );
    if (response.status === 'Abort') {
        throw response.reason;
    }
    return response.json;
}

const CurrencyInfoSchemaArk = type({
    code: type.string.as<CurrencyCode>(),
    name: 'string',
    type: "'fiat' | 'stablecoin' | 'crypto'",
    decimals: 'number.integer',
    rateValue: 'number',
    rateQuote: type.string.as<CurrencyCode>(),
    icon: type('string.url | null'),
});

const CurrencyInfosSchema = Decoder.prepare(unSnakeByMutation)(
    Decoder.morph(CurrencyInfoSchemaArk.array(), t =>
        t.map(({icon, ...t}) => ({
            ...t,
            icon: icon ?? defaultIcon,
        }))
    )
) satisfies StandardSchemaV1<unknown, CurrencyInfo[]>;
